function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCommentBubbles = function SvgCommentBubbles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M1.097 9.615a.75.75 0 0 1 .156.63L.515 13.57a.35.35 0 0 0 .504.386l3.609-1.892a.73.73 0 0 1 .499-.062A8.601 8.601 0 0 0 7 12.205c3.866 0 7-2.508 7-5.603S10.866 1 7 1 0 3.508 0 6.603c0 1.109.402 2.142 1.097 3.012zM13 17.208c-3.183 0-5.87-1.701-6.72-4.029.237.017.477.026.72.026 4.199 0 8-2.76 8-6.603a5.7 5.7 0 0 0-.012-.371C17.886 6.917 20 9.064 20 11.605c0 1.109-.403 2.142-1.097 3.012a.75.75 0 0 0-.156.63l.739 3.325a.35.35 0 0 1-.504.386l-3.609-1.892a.73.73 0 0 0-.499-.062 8.617 8.617 0 0 1-1.874.204z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgCommentBubbles;